<div class="container-fluid">
  <div class="row py-3">
    <div class="col">
      <h2>Contacts</h2>
    </div>
    <div class="col-2">
      <button class="btn btn-primary" (click)="addContact()">
        Add Contact
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col" style="height: 700px">
      @if (suppliedGridQueryData) {
        <app-contacts-grid
          [suppliedQueryData]="suppliedGridQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          (actionEvent)="onActionEvent($event)"
          [reloadGridData]="reloadGridData"
          [gridName]="'ClientSiteContacts'"
        ></app-contacts-grid>
      }
    </div>
  </div>
</div>
